(() => {
  if (window.__ss26GolfGridTabsV4LessVariantInitialised) return;
  window.__ss26GolfGridTabsV4LessVariantInitialised = true;

  const rootSelector = '[data-ss26-grid-tabs]';
  const tabSelector = '[data-ss26-filter]';
  const lookFilterSelector = '[data-ss26-look-filter]';
  const contentId = 'CollectionAjaxContent';
  const swatchSelector = '[data-ss26-card-swatch]';
  const cardSelector = '[data-ss26-product-card]';
  const editorialSelector = '.ss26-editorial-tile';
  const cache = new Map();
  const listingIndex = new Map();
  const editorialLibrary = new Map();
  const extraProductLibraries = new Map();
  let activeRequest;
  let requestSequence = 0;
  let lastTouchActivation = 0;
  let keyboardActivationTimer;

  const getRoot = () => document.querySelector(rootSelector);
  const getTabs = (root) => Array.from(root.querySelectorAll(tabSelector));
  const desktopPointer = () => window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches;

  const setStatus = (root, message) => {
    const status = root.querySelector('[data-ss26-grid-status]');
    if (status) status.textContent = message;
  };

  const track = (eventName, parameters = {}) => {
    if (!Array.isArray(window.dataLayer)) return;
    window.dataLayer.push({ event: eventName, ...parameters });
  };

  const setActiveTab = (root, filter) => {
    const content = document.getElementById(contentId);
    let activeTab;

    getTabs(root).forEach((tab) => {
      const isActive = tab.dataset.ss26Filter === filter;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
      if (isActive) activeTab = tab;
    });

    root.dataset.ss26ActiveFilter = filter;
    if (content && activeTab) content.setAttribute('aria-labelledby', activeTab.id);
  };

  const normalizeListingValue = (value) => value?.trim().toLowerCase() || '';
  const normalizeListingTitle = (value) => normalizeListingValue(value).replace(/\s+/g, '');

  const prepareCardListing = (card) => {
    if (card.dataset.ss26ListingPrepared === 'true') return;

    const title = card.querySelector('.grid-product__title, .ss26-look-product__title')?.textContent;
    const descriptor = card.querySelector('.ss26-product-card__descriptor, .ss26-look-product__label')?.textContent;
    const descriptorParts = descriptor?.split('·').map((part) => part.trim()) || [];
    const colour = card.querySelector('[data-ss26-card-color]')?.textContent || descriptorParts[1];
    const image = card.querySelector('[data-ss26-card-primary-media] img');
    const link = card.querySelector('[data-ss26-card-link]');

    card.dataset.ss26ListingFamily = `${normalizeListingTitle(title)}::${normalizeListingValue(descriptorParts[0])}`;
    card.dataset.ss26ListingColour = normalizeListingValue(colour);
    card.dataset.ss26ListingImage = image?.getAttribute('data-src') || image?.getAttribute('src') || '';
    card.dataset.ss26ListingUrl = link?.getAttribute('href') || '';
    card.dataset.ss26ListingPrepared = 'true';
  };

  const registerCardListing = (card) => {
    prepareCardListing(card);
    const family = card.dataset.ss26ListingFamily;
    const colour = card.dataset.ss26ListingColour;
    if (!family || !colour) return;

    listingIndex.set(`${family}::${colour}`, {
      imageUrl: card.dataset.ss26ListingImage,
      productUrl: card.dataset.ss26ListingUrl
    });
  };

  const prepareCardListings = (scope) => {
    scope.querySelectorAll(cardSelector).forEach(registerCardListing);
  };

  const registerEditorialTiles = (scope) => {
    scope.querySelectorAll('.ss26-editorial-grid-item[data-ss26-editorial-id]').forEach((tile) => {
      editorialLibrary.set(tile.dataset.ss26EditorialId, tile.cloneNode(true));
    });
  };

  const registerExtraProducts = () => {
    document.querySelectorAll('template[data-ss26-extra-products]').forEach((template) => {
      const filter = template.dataset.ss26ExtraProducts;
      const cards = Array.from(template.content.querySelectorAll(cardSelector));
      cards.forEach(registerCardListing);
      extraProductLibraries.set(filter, cards.map((card) => card.cloneNode(true)));
    });
  };

  const getEditorialTiles = (filter) => {
    const matchingTiles = Array.from(editorialLibrary.values()).filter((tile) => {
      const filters = tile.dataset.ss26EditorialFilters?.split(',') || [];
      return filter === 'all' ? filters.includes('all') : filters.includes(filter);
    });

    return matchingTiles
      .sort((tileA, tileB) => Number(tileA.dataset.ss26EditorialPosition) - Number(tileB.dataset.ss26EditorialPosition))
      .map((tile, index) => ({
        tile: tile.cloneNode(true),
        position: filter === 'all' ? Number(tile.dataset.ss26EditorialPosition) : (index + 1) * 4
      }));
  };

  const resolveSwatchTarget = (swatch) => {
    const card = swatch.closest(cardSelector);
    const colour = swatch.dataset.ss26SwatchColor;
    if (!card) return {};

    registerCardListing(card);
    const matchingListing = listingIndex.get(
      `${card.dataset.ss26ListingFamily}::${normalizeListingValue(colour)}`
    );
    const renderedProductUrl = swatch.dataset.ss26SwatchUrl || swatch.getAttribute('href');
    const isCompleteLookCard = card.classList.contains('ss26-look-product');

    return {
      colour,
      imageUrl: matchingListing?.imageUrl || swatch.dataset.ss26SwatchImage,
      productUrl: isCompleteLookCard
        ? renderedProductUrl || matchingListing?.productUrl
        : matchingListing?.productUrl || renderedProductUrl
    };
  };

  const syncCardColourText = (card, colour) => {
    if (!colour) return;

    const colourLabel = card.querySelector('[data-ss26-card-color]');
    if (colourLabel) colourLabel.textContent = colour;
    if (!card.classList.contains('ss26-look-product')) return;

    const lookLabel = card.querySelector('.ss26-look-product__label');
    if (!lookLabel) return;

    const configuredPrefix = lookLabel.dataset.ss26LookLabelPrefix
      || lookLabel.textContent.split('·')[0]?.trim()
      || '';
    lookLabel.dataset.ss26LookLabelPrefix = configuredPrefix;
    lookLabel.textContent = configuredPrefix ? `${configuredPrefix} · ${colour}` : colour;
  };

  const previewSwatch = (swatch, target = resolveSwatchTarget(swatch)) => {
    const card = swatch.closest(cardSelector);
    if (!card) return;

    const { imageUrl, productUrl, colour } = target;
    const media = card.querySelector('[data-ss26-card-primary-media]');
    const image = media?.querySelector('img');

    if (image && imageUrl) {
      image.removeAttribute('srcset');
      image.removeAttribute('data-srcset');
      image.setAttribute('src', imageUrl);
      image.setAttribute('data-src', imageUrl);
    }

    if (productUrl) {
      swatch.setAttribute('href', productUrl);
      card.querySelectorAll('[data-ss26-card-link]').forEach((link) => {
        link.setAttribute('href', productUrl);
      });
    }

    card.querySelectorAll(swatchSelector).forEach((item) => {
      const selected = item === swatch;
      item.classList.toggle('is-active', selected);
      if (selected) {
        item.setAttribute('aria-current', 'true');
      } else {
        item.removeAttribute('aria-current');
      }
    });

    syncCardColourText(card, colour);
    card.classList.add('is-ss26-swatch-preview');
  };

  const activateMobileSwatch = (swatch) => {
    const card = swatch.closest(cardSelector);
    const target = resolveSwatchTarget(swatch);
    const { productUrl } = target;
    if (!card || !productUrl) return;

    if (card.dataset.ss26MobilePreviewUrl === productUrl) {
      window.location.assign(productUrl);
      return;
    }

    previewSwatch(swatch, target);
    card.dataset.ss26MobilePreviewUrl = productUrl;
  };

  const refreshThemeBehaviours = (content) => {
    prepareCardListings(content);
    content.querySelectorAll('[data-aos]').forEach((element) => {
      element.classList.add('aos-animate');
    });
    document.dispatchEvent(new CustomEvent('ss26:collection:updated', {
      detail: { content }
    }));
    window.dispatchEvent(new Event('scroll'));
  };

  const buildRequestUrl = (rawUrl) => {
    const requestUrl = new URL(rawUrl, window.location.origin);
    const currentUrl = new URL(window.location.href);
    const currentSort = currentUrl.searchParams.get('sort_by');
    const previewThemeId = currentUrl.searchParams.get('preview_theme_id');

    requestUrl.searchParams.delete('page');
    requestUrl.searchParams.delete('section_id');
    if (currentSort) requestUrl.searchParams.set('sort_by', currentSort);
    if (previewThemeId) requestUrl.searchParams.set('preview_theme_id', previewThemeId);
    return requestUrl;
  };

  const getRequestUrls = (tab) => {
    const rawUrls = [tab.dataset.ss26FilterUrl, tab.dataset.ss26FilterUrlSecondary].filter(Boolean);
    return Array.from(new Set(rawUrls)).map(buildRequestUrl);
  };

  const getNextContent = async (requestUrl, signal) => {
    const response = await fetch(requestUrl.href, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal
    });
    if (!response.ok) throw new Error(`Collection request failed: ${response.status}`);

    const html = await response.text();
    const nextDocument = new DOMParser().parseFromString(html, 'text/html');
    const nextContent = nextDocument.getElementById(contentId);
    if (!nextContent) throw new Error('Collection content was not returned');
    return nextContent;
  };

  const getAllPageContents = async (requestUrl, signal) => {
    const firstContent = await getNextContent(requestUrl, signal);
    const pageUrls = new Map();

    firstContent.querySelectorAll('.pagination a[href]').forEach((link) => {
      const pageUrl = new URL(link.getAttribute('href'), requestUrl.href);
      const page = Number(pageUrl.searchParams.get('page'));
      if (!Number.isFinite(page) || page <= 1) return;

      const normalizedUrl = buildRequestUrl(pageUrl.href);
      normalizedUrl.searchParams.set('page', String(page));
      pageUrls.set(page, normalizedUrl);
    });

    const remainingContents = await Promise.all(
      Array.from(pageUrls.entries())
        .sort(([pageA], [pageB]) => pageA - pageB)
        .map(([, pageUrl]) => getNextContent(pageUrl, signal))
    );

    return [firstContent, ...remainingContents];
  };

  const insertEditorialTiles = (grid, editorialTiles) => {
    editorialTiles.forEach(({ tile, position }) => {
      const productCards = Array.from(grid.children).filter((child) => child.matches(cardSelector));
      const anchor = productCards[Math.min(position, productCards.length) - 1];
      if (anchor) {
        anchor.after(tile);
      } else {
        grid.appendChild(tile);
      }
    });
  };

  const mergeGroupedContents = (contents, filter) => {
    const primary = contents[0]?.cloneNode(true);
    if (!primary) throw new Error('Collection content was not returned');

    const primaryGrid = primary.querySelector('.product-grid-container');
    if (!primaryGrid) return { markup: primary.innerHTML, productCount: 0 };

    contents.forEach(registerEditorialTiles);
    const seenHandles = new Set();
    const seenFamilies = new Set();
    const representativeCards = [];

    contents.forEach((content) => {
      content.querySelectorAll(`.product-grid-container > ${cardSelector}`).forEach((sourceCard) => {
        const handle = sourceCard.dataset.productHandle;
        if (handle && seenHandles.has(handle)) return;
        if (handle) seenHandles.add(handle);

        registerCardListing(sourceCard);
        const family = sourceCard.dataset.ss26ListingFamily || handle;
        if (!family || seenFamilies.has(family)) return;
        seenFamilies.add(family);
        representativeCards.push(sourceCard.cloneNode(true));
      });
    });

    (extraProductLibraries.get(filter) || []).forEach((sourceCard) => {
      const handle = sourceCard.dataset.productHandle;
      if (handle && seenHandles.has(handle)) return;
      if (handle) seenHandles.add(handle);

      registerCardListing(sourceCard);
      const family = sourceCard.dataset.ss26ListingFamily || handle;
      if (!family || seenFamilies.has(family)) return;
      seenFamilies.add(family);
      representativeCards.push(sourceCard.cloneNode(true));
    });

    primaryGrid.replaceChildren(...representativeCards);
    insertEditorialTiles(primaryGrid, getEditorialTiles(filter));
    primary.querySelectorAll('.pagination').forEach((pagination) => pagination.remove());
    return {
      markup: primary.innerHTML,
      productCount: representativeCards.length
    };
  };

  const loadFilter = async (tab, { force = false } = {}) => {
    const root = getRoot();
    const currentContent = document.getElementById(contentId);
    if (!root || !currentContent || !tab.dataset.ss26FilterUrl) return false;

    const filter = tab.dataset.ss26Filter;
    if (!force && root.dataset.ss26ActiveFilter === filter) return true;

    const requestUrls = getRequestUrls(tab);
    const cacheKey = `${filter}:${requestUrls.map((url) => url.href).join('|')}`;
    const requestId = ++requestSequence;
    const preservedScroll = window.scrollY;

    if (activeRequest) activeRequest.abort();
    activeRequest = new AbortController();

    currentContent.classList.add('is-ss26-loading');
    currentContent.setAttribute('aria-busy', 'true');
    setStatus(root, '商品載入中');

    try {
      const nextResult = cache.has(cacheKey)
        ? cache.get(cacheKey)
        : mergeGroupedContents((await Promise.all(
          requestUrls.map((requestUrl) => getAllPageContents(requestUrl, activeRequest.signal))
        )).flat(), filter);
      if (requestId !== requestSequence) return null;

      cache.set(cacheKey, nextResult);
      currentContent.innerHTML = nextResult.markup;
      setActiveTab(root, filter);
      refreshThemeBehaviours(currentContent);
      root.dataset.ss26LessVariantReady = 'true';
      root.dataset.ss26VisibleProductCount = String(nextResult.productCount);
      setStatus(root, `${tab.textContent.trim()}：顯示 ${nextResult.productCount} 個款式`);
      window.scrollTo({ top: preservedScroll, left: 0, behavior: 'auto' });
      return true;
    } catch (error) {
      if (error.name === 'AbortError') return null;
      setStatus(root, '商品暫時無法切換，請稍後再試');
      return false;
    } finally {
      if (requestId === requestSequence) {
        currentContent.classList.remove('is-ss26-loading');
        currentContent.removeAttribute('aria-busy');
      }
    }
  };

  document.addEventListener('pointerover', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (!swatch || !desktopPointer()) return;
    previewSwatch(swatch);
  });

  document.addEventListener('focusin', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (swatch) previewSwatch(swatch);
  });

  document.addEventListener('touchend', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (!swatch || desktopPointer()) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    lastTouchActivation = performance.now();
    activateMobileSwatch(swatch);
  }, { capture: true, passive: false });

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (!swatch) return;

    if (desktopPointer()) {
      const { productUrl } = resolveSwatchTarget(swatch);
      if (productUrl) swatch.setAttribute('href', productUrl);
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    if (performance.now() - lastTouchActivation < 700) return;
    activateMobileSwatch(swatch);
  }, true);

  document.addEventListener('click', async (event) => {
    const tab = event.target.closest(tabSelector);
    if (!tab || !tab.closest(rootSelector)) return;

    event.preventDefault();
    track('ss26_collection_filter', {
      filter: tab.dataset.ss26Filter,
      source: 'collection-tabs'
    });
    await loadFilter(tab);
  });

  document.addEventListener('click', async (event) => {
    const lookLink = event.target.closest(lookFilterSelector);
    if (!lookLink) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    const root = getRoot();
    if (!root) return;

    const filter = lookLink.dataset.ss26LookFilter;
    const tab = getTabs(root).find((item) => item.dataset.ss26Filter === filter);
    if (!tab) return;

    track('ss26_shop_by_look', {
      filter,
      source: lookLink.dataset.ss26TrackSource || 'campaign'
    });
    const loaded = await loadFilter(tab);
    if (loaded !== true) return;
    root.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });
    tab.focus({ preventScroll: true });
  });

  document.addEventListener('click', async (event) => {
    const editorialLink = event.target.closest(editorialSelector);
    if (!editorialLink) return;

    const editorialItem = editorialLink.closest('[data-ss26-editorial-id]');
    const targetFilter = editorialLink.dataset.ss26EditorialTargetFilter;
    track('ss26_editorial_click', {
      editorial_id: editorialItem?.dataset.ss26EditorialId || 'unknown',
      destination: targetFilter || editorialLink.getAttribute('href') || ''
    });

    if (!targetFilter) return;

    const root = getRoot();
    const tab = root && getTabs(root).find((item) => item.dataset.ss26Filter === targetFilter);
    if (!root || !tab) return;

    event.preventDefault();
    const loaded = await loadFilter(tab);
    if (loaded !== true) return;

    root.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });
    tab.focus({ preventScroll: true });
  });

  const queueKeyboardActivation = (tab) => {
    window.clearTimeout(keyboardActivationTimer);
    keyboardActivationTimer = window.setTimeout(() => {
      track('ss26_collection_filter', {
        filter: tab.dataset.ss26Filter,
        source: 'collection-tabs-keyboard'
      });
      loadFilter(tab);
    }, 80);
  };

  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest(tabSelector);
    const root = tab?.closest(rootSelector);
    if (!root) return;

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      queueKeyboardActivation(tab);
      return;
    }

    const tabs = getTabs(root);
    const currentIndex = tabs.indexOf(tab);
    let nextIndex = currentIndex;

    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = tabs.length - 1;
    if (nextIndex === currentIndex) return;

    event.preventDefault();
    tabs[nextIndex].focus({ preventScroll: true });
    queueKeyboardActivation(tabs[nextIndex]);
  });

  const readyRoot = getRoot();
  if (readyRoot) {
    prepareCardListings(document);
    registerEditorialTiles(document);
    registerExtraProducts();
    readyRoot.dataset.ss26ScriptReady = 'true';
    readyRoot.dataset.ss26ProductPreviewReady = 'true';
    setActiveTab(readyRoot, readyRoot.dataset.ss26ActiveFilter || 'all');
    const activeTab = getTabs(readyRoot).find((tab) => tab.classList.contains('is-active'));
    const activeFilter = readyRoot.dataset.ss26ActiveFilter || 'all';
    const serverGrid = document.querySelector(
      `#${contentId} .product-grid-container[data-ss26-server-canonical="true"]`
    );
    const requiresMergedSources = activeFilter === 'bottoms' || activeFilter === 'skirt';

    if (serverGrid && !requiresMergedSources) {
      const serverCards = serverGrid.querySelectorAll(cardSelector);
      readyRoot.dataset.ss26LessVariantReady = 'server';
      readyRoot.dataset.ss26VisibleProductCount = String(serverCards.length);
      setStatus(
        readyRoot,
        `${activeTab?.textContent.trim() || 'ALL'}：顯示 ${serverCards.length} 個款式`
      );
    } else if (activeTab) {
      const hydrate = () => loadFilter(activeTab, { force: true });
      if ('IntersectionObserver' in window) {
        const hydrationObserver = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          hydrationObserver.disconnect();
          hydrate();
        }, { rootMargin: '600px 0px' });
        hydrationObserver.observe(readyRoot);
      } else {
        hydrate();
      }
    }
  }
})();
